export type RetryOptions = {
  baseInterval: number;
  currentAttempt: number;
  maxInterval: number;
};

export const DEFAULT_ATTEMPTS_CAP = 64;

/**
 * Manages retries with exponential backoff and jitter based on the input attempt number
 *
 * This implementation follows AWS's recommended "Full Jitter" pattern:
 * https://aws.amazon.com/blogs/architecture/exponential-backoff-and-jitter/
 *
 * @param baseInterval The base interval in milliseconds
 * @param currentAttempt The current attempt number
 * @param maxInterval The maximum interval in milliseconds
 * @returns The delay in milliseconds for the next retry, if any
 */
export const getDelayWithExponentialBackoff = ({
  baseInterval,
  currentAttempt,
  maxInterval,
}: RetryOptions): number => {
  // Calculate delay with Full Jitter
  const cap = maxInterval;
  // We cap the exponential backoff to the attemptsCap to avoid computational overflows
  const exponentialBackoff =
    baseInterval * Math.pow(2, Math.min(currentAttempt - 1, DEFAULT_ATTEMPTS_CAP));
  const jitteredDelay = Math.random() * Math.min(cap, exponentialBackoff);

  return jitteredDelay;
};
